/** 与后端 game/constants/collection_types.py 一致 */
export const COLLECTION_TYPE_HOT = 'hot_collection';
export const COLLECTION_TYPE_RECOMMENDED = 'recommended_collection';
export const COLLECTION_TYPE_LEADERBOARD = 'leaderboard_collection';
export const COLLECTION_TYPE_PERSONALIZED = 'personalized_collection';
export const COLLECTION_TYPE_NORMAL = 'normal_collection';

export const COLLECTION_TYPE_OPTIONS = [
  { value: COLLECTION_TYPE_HOT, label: '热门合集' },
  { value: COLLECTION_TYPE_RECOMMENDED, label: '推荐合集' },
  { value: COLLECTION_TYPE_LEADERBOARD, label: '排行榜' },
  { value: COLLECTION_TYPE_PERSONALIZED, label: '个性化推荐合集' },
  { value: COLLECTION_TYPE_NORMAL, label: '普通合集' },
] as const;
